export const link = [
    {
        id: 1,
        name: "Ֆիզիկա՝ Ֆիզիկական երևույթներ (Դասի սահիկաշար)",
        info: "https://drive.google.com/file/d/1SkuqvjrmoHa41CS26TKmLGssi9vrxeYK/view?usp=sharing",
        menuItemId: 3
    },
    {
        id: 2,
        name: "Բնության գիտ. մեթոդներ (Դասի սահիկաշար)",
        info: "https://drive.google.com/file/d/1SkuqvjrmoHa41CS26TKmLGssi9vrxeYK/view?usp=sharing",
        menuItemId: 3
    },
    {
        id: 3,
        name: "Չափումներ պարզագույն սարքերով (Էլ. նյութ)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#162,24405",
        menuItemId: 3
    },
    {
        id: 4,
        name: "Ֆիզիկական մարմին և նյութ (Դասի սահիկաշար)",
        info: "https://drive.google.com/file/d/1uGLA3mgobGenZee71WQxSYl-oucRasKr/view?usp=sharing",
        menuItemId: 3
    },
    {
        id: 5,
        name: "Մոլեկուլներ և ատոմներ (Էլ. նյութ 1)",
        info: "http://esource.armedu.am/app/?subject=6&grade=10#46,24437",
        menuItemId: 4
    },
    {
        id: 6,
        name: "Մոլեկուլներ և ատոմներ (Էլ. նյութ 2)",
        info: "http://esource.armedu.am/app/?subject=6&grade=10#46,24439",
        menuItemId: 3
    },
    {
        id: 7,
        name: "Մոլեկուլների շարժում՝ Դիֆուզիա (Էլ. նյութ)",
        info: "http://esource.armedu.am/app/?subject=6&grade=10#46,24447",
        menuItemId: 3
    },
    {
        id: 8,
        name: "Մոլեկուլների քաոսային շարժման արագություն՝ ջերմաստիճան (Էլ. նյութ)",
        info: "http://esource.armedu.am/app/?subject=6&grade=10#46,24440",
        menuItemId: 3
    },
    {
        id: 9,
        name: "Ջերմաստիճանային սանդղակ, ջերմաչափ (Էլ. նյութ)",
        info: "http://esource.armedu.am/app/?subject=6&grade=10#46,24448",
        menuItemId: 3
    },
    {
        id: 10,
        name: "Շարժման հետագիծ, ճանապարհ (Դասի սահիկաշար)",
        info: "https://drive.google.com/file/d/1a7LuQX0ezuANlAWmMHlQ-OYoxK9Jw-3O/view?usp=sharing",
        menuItemId: 3
    },
    {
        id: 11,
        name: "Շարժման հետագիծ (Էլ. նյութ)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#15,24315",
        menuItemId: 3
    },
    {
        id: 12,
        name: "Նյութի խտություն – զանգված & ծավալ (Էլ. նյութ)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#15,24318",
        menuItemId: 3
    },
    {
        id: 13,
        name: "Մարմնի փոխազդեցություն, ուժ (Էլ. նյութ)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#15,24319",
        menuItemId: 3
    },
    {
        id: 14,
        name: "Մարմնի փոխազդեցություն, ուժ (Էլ. նյութ լր.)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#15,24327",
        menuItemId: 3
    },
    {
        id: 15,
        name: "Մարմնի փոխազդեցություն, ուժ (Էլ. նյութ 3)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#15,24332",
        menuItemId: 3
    },
    {
        id: 16,
        name: "Շարժական ձգողականություն, ծանրության ուժ (Էլ. նյութ)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#15,24331",
        menuItemId: 3
    },
    {
        id: 17,
        name: "Շարժական ձգողականություն, ծանրության ուժ (Էլ. նյութ լր.)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#15,24327",
        menuItemId: 3
    },
    {
        id: 18,
        name: "Արտադարձության ուժ, Հուկի օրենք (Էլ. նյութ)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#15,24325",
        menuItemId: 3
    },
    {
        id: 19,
        name: "Արտադարձության ուժ (Էլ. նյութ 2)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#15,24329",
        menuItemId: 3
    },
    {
        id: 20,
        name: "Մարմնի կշիռ (Դասի սահիկաշար)",
        info: "https://drive.google.com/file/d/1DyCYSyxqagHUdHL5AhgO8jurxqyb84N/view?usp=sharing",
        menuItemId: 3
    },
    {
        id: 21,
        name: "Շփման ուժ (Դասի սահիկաշար)",
        info: "https://drive.google.com/file/d/1nd3ZBdCmCdMxBq4N7bu72TgVFc-0MtNZ/view?usp=sharing",
        menuItemId: 3
    },
    {
        id: 22,
        name: "Ուղղով ուղղված երկու ուժերի գումարումը (Դասի սահիկաշար)",
        info: "https://drive.google.com/file/d/1DyCYSyxqagHUdHL5AhgO8jurxqyb84N/view?usp=sharing",
        menuItemId: 3
    },
    {
        id: 23,
        name: "Մեխանիկ աշխատանք (Էլ. նյութ)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#17,24335",
        menuItemId: 3
    },
    {
        id: 24,
        name: "Զորություն (Դասի սահիկաշար)",
        info: "https://drive.google.com/file/d/1n_kKGpABWSgMfnkpeeSJDz0fQ2UsSaI1/view?usp=sharing",
        menuItemId: 3
    },
    {
        id: 25,
        name: "Պարզ մեխանիզմներ (ՀՏԿ, ԼԾԱԿ կանոն) (Էլ. նյութ)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#17,24333",
        menuItemId: 3
    },
    {
        id: 26,
        name: "Պարզ մեխանիզմներ (Էլ. նյութ 2)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#17,24334",
        menuItemId: 3
    },
    {
        id: 27,
        name: "Պարզ մեխանիզմներ (Էլ. նյութ 3)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#17,24337",
        menuItemId: 3
    },
    {
        id: 28,
        name: "Պարզ մեխանիզմներ (Էլ. նյութ 4)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#17,24336",
        menuItemId: 3
    },
    {
        id: 29,
        name: "Լծակի հավասարակշռության պայման (Դասի սահիկաշար)",
        info: "https://drive.google.com/file/d/1PS1_nptk1D4NXxwE9-3cBRG7QBrx9lT2/view?usp=sharing",
        menuItemId: 3
    },
    {
        id: 30,
        name: "Լաբ. աշխատանք 7: Լծակի հավասարակշռություն (Էլ. նյութ)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#17,24339",
        menuItemId: 3
    },
    {
        id: 31,
        name: "Լաբ. աշխատանք 7 (Էլ. նյութ 2)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#17,24340",
        menuItemId: 3
    },
    {
        id: 32,
        name: "Ճնշում՝ ճնշման ուժ (Էլ. նյութ)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#21,24371",
        menuItemId: 3
    },
    {
        id: 33,
        name: "Ճնշում (Էլ. նյութ 2)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#21,24377",
        menuItemId: 3
    },
    {
        id: 34,
        name: "Ճնշում (Դասի սահիկաշար)",
        info: "https://drive.google.com/file/d/1SkuqvjrmoHa41CS26TKmLGssi9vrxeYK/view?usp=sharing",
        menuItemId: 3
    },
    {
        id: 35,
        name: "Գազի ճնշում (Էլ. նյութ)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#21,24359",
        menuItemId: 3
    },
    {
        id: 36,
        name: "Գազի ճնշում (Էլ. նյութ 2)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#21,24360",
        menuItemId: 3
    },
    {
        id: 37,
        name: "Ճնշման հաղորդում գազերում և հեղուկներում (Էլ. նյութ)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#21,24361",
        menuItemId: 3
    },
    {
        id: 38,
        name: "Ճնշման հաղորդում (Էլ. նյութ 2)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#21,24362",
        menuItemId: 3
    },
    {
        id: 39,
        name: "Հիդրոստատիկ ճնշում (Էլ. նյութ)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#21,24363",
        menuItemId: 3
    },
    {
        id: 40,
        name: "Ճնշման ազդեցություն անոթի պատերին (Էլ. նյութ)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#21,24364",
        menuItemId: 3
    },
    {
        id: 41,
        name: "Հիդրոստատիկ ճնշում (Էլ. նյութ լր.)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#21,24372",
        menuItemId: 3
    },
    {
        id: 42,
        name: "Ճնշում (Էլ. նյութ լր.)",
        info: "http://esource.armedu.am/app/?subject=6&grade=11#21,24379",
        menuItemId: 3
    },
    {
        id: 43,
        name: "Վերջին դասի դասի սահիկաշար",
        info: "https://drive.google.com/file/d/1CieF1FP3oZgxOIo5oI-1kdqN5zXBoUR7/view?usp=sharing",
        menuItemId: 3
    }
];

